// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage'; // Add this import

const firebaseConfig = {
  apiKey: "AIzaSyBOy2KP-iqlhAwq4I13wbZanEYXg_52X5E",
  authDomain: "travelwitheducation-5667d.firebaseapp.com",
  databaseURL: "https://travelwitheducation-5667d-default-rtdb.firebaseio.com",
  projectId: "travelwitheducation-5667d",
  storageBucket: "travelwitheducation-5667d.firebasestorage.app",
  messagingSenderId: "527305789253",
  appId: "1:527305789253:web:609c12fdaf5b0f73c0382c",
  measurementId: "G-PXPK8LY93W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Database and Storage
export const db = getDatabase(app);
export const storage = getStorage(app); // Add this export